package gr.tech.GRAttestation.infrastructure.api

import gr.tech.GRAttestation.models.api.ApiResponse
import gr.tech.GRAttestation.models.api.PaginatedResult
import gr.tech.GRAttestation.models.stores.STORE_STATUS
import gr.tech.GRAttestation.models.stores.StoreDTO
import gr.tech.GRAttestation.models.stores.StorePreviewDTO
import gr.tech.GRAttestation.models.tables.BasicTableFilters
import gr.tech.GRAttestation.util.ROUTES
import kotlinx.serialization.json.Json

// CREATE
suspend fun adminCreateNewStore(
    storeDTO: StoreDTO,
    onSuccess: (ApiResponse<String>) -> Unit,
    onError: (String) -> Unit,
) {
    try {
        val result: ApiResponse<String> = safeApiCallStringBody(
            url = ROUTES.BACKEND.STORES.ADMIN_STORES,
            method = "POST",
            body = Json.encodeToString(storeDTO)
        )

        onSuccess(result)
    } catch (e: Exception) {
        onError("failed to adminCreateNewStore(): $e")
        return
    }
}

// READ
suspend fun adminFetchAllStores(
    pageNumber: Int,
    pageSize: Int,
    storeStatus: STORE_STATUS,
    basicFilters: BasicTableFilters,
    onResponse: (ApiResponse<PaginatedResult<StoreDTO>>) -> Unit,
    onError: (String) -> Unit,
) {
    val urlWithParameters = ROUTES.BACKEND.STORES.ADMIN_STORES +
            "?page=$pageNumber&pageSize=$pageSize" +
            "&dateColumn=${basicFilters.dateColumn}" +
            "&asc=${basicFilters.isAscending}" +
            "&before=${basicFilters.isBefore}" +
            "&date=${basicFilters.dateString}" +
            "&status=${storeStatus.name}"

    try {
        val result: ApiResponse<PaginatedResult<StoreDTO>> = safeApiCallStringBody(
            url = urlWithParameters,
            method = "GET",
        )

        onResponse(result)
    } catch (e: Exception) {
        onError("failed to adminFetchAllProjects(): $e")
        return
    }
}

suspend fun adminFetchStoreById(
    storeId: String,
    onResponse: (ApiResponse<StoreDTO>) -> Unit,
    onError: (String) -> Unit,
) {
    try {
        val result: ApiResponse<StoreDTO> = safeApiCallStringBody(
            url = "${ROUTES.BACKEND.STORES.ADMIN_STORES}?id=$storeId",
            method = "GET",
        )

        onResponse(result)
    } catch (e: Exception) {
        onError("Failed to adminFetchStoreById()")
        return
    }
}

// UPDATE

suspend fun adminUpdateStore(
    editedStore: StoreDTO,
    onSuccess: (ApiResponse<String>) -> Unit,
    onError: (String) -> Unit,
) {
    try {
        val result: ApiResponse<String> = safeApiCallStringBody(
            url = ROUTES.BACKEND.STORES.ADMIN_STORES,
            method = "PUT",
            body = Json.encodeToString(editedStore)
        )

        onSuccess(result)
    } catch (e: Exception) {
        onError("Failed to adminUpdateStore()")
        return
    }
}

// DELETE
suspend fun adminDeleteStoreByID(
    storeId: Int,
    restore: Boolean = false,
    onSuccess: (ApiResponse<Boolean>) -> Unit,
    onError: (String) -> Unit,
) {
    var url = "${ROUTES.BACKEND.STORES.ADMIN_STORES_DELETE}/$storeId"
    if (restore) url += "/restore"

    val method = if (restore) "PUT" else "DELETE"

    try {
        val result: ApiResponse<Boolean> = safeApiCallStringBody(
            url = url,
            method = method,
        )

        onSuccess(result)
    } catch (e: Exception) {
        onError("Failed to adminDeleteProjectByUUID()")
        return
    }
}

/*
    STORE USER FUNCTIONS
*/

suspend fun fetchStoreByCurrentUser(
    onSuccess: (ApiResponse<StorePreviewDTO>) -> Unit,
    onError: (String) -> Unit,
) {
    try {
        val result: ApiResponse<StorePreviewDTO> = safeApiCallStringBody(
            url = ROUTES.BACKEND.STORES.STORE_USERS_STORES,
            method = "GET",
        )

        onSuccess(result)
    } catch (e: Exception) {
        onError("failed to fetchStoreById(): $e")
        return
    }
}